import { render } from "./prestore.vue?vue&type=template&id=21ef55ee&scoped=true"
import script from "./prestore.vue?vue&type=script&lang=js"
export * from "./prestore.vue?vue&type=script&lang=js"

import "./prestore.vue?vue&type=style&index=0&id=21ef55ee&scoped=true&lang=css"
import "./prestore.vue?vue&type=style&index=1&id=21ef55ee&lang=css"
script.render = render
script.__scopeId = "data-v-21ef55ee"

export default script